import { JsonObject } from '../../helpers';
import { ConnectorApiKeyConfig, ConnectorFeatureSet } from './';
import { ConnectorModel } from './connector.model';
import NvidiaLogo from '@/assets/connector-icons/nvidia.png';

export class NvidiaNimConnectorModel extends ConnectorModel {
  config: ConnectorApiKeyConfig;

  constructor(props: JsonObject = {}) {
    super(props);

    const data = props as Record<keyof ConnectorModel, unknown>;

    this.type = 'nvidia-nim';
    this.typeLabel = 'NVIDIA NIM';
    this.iconSVG = NvidiaLogo;

    this.supportedFeatures = (data.supportedFeatures as ConnectorFeatureSet) || {
      siem: false,
      privateModels: true,
      contextData: false,
      ingress: false,
    };

    this.config = (data.config as ConnectorApiKeyConfig) || {
      apiKey: '',
    };

    this.configSecrets = ['apiKey'];
    this.canListProviderModels = true;
  }
}
